<template>
  <div id="app">
    <HeaderComponent />
    <Preview @switchScreen="screenSwitcher" v-if="!screen || screen === 'preview'" />
    <transition name="fade">
      <Quiz @switchScreen="screenSwitcher" v-if="screen === 'quiz'" />
    </transition>
    <transition name="fade">
      <PhoneEnter @sendPhone="getPhone" @switchScreen="screenSwitcher" v-if="screen === 'phoneEnter'" />
    </transition>
    <transition name="fade">
      <Result :userPhone="phone" v-if="screen === 'result'" />
    </transition>
  </div>
</template>

<script>
import HeaderComponent from "./components/Header";
import Preview from "./screens/Preview";
import PhoneEnter from "./screens/PhoneEnter";
import Result from "./screens/Result";
import Quiz from "./screens/Quiz";
import "normalize.css";
export default {
  name: "app",
  components: {
    HeaderComponent,
    Preview,
    Quiz,
    PhoneEnter,
    Result
  },
  data() {
    return {
      screen: "preview",
      phone: null
    };
  },
  mounted() {
    setTimeout(() => {
      this.$confetti.start();
      setTimeout(() => this.$confetti.stop(), 2000);
    }, 1000);
  },
  methods: {
    screenSwitcher(screen) {
      this.screen = screen;
    },
    getPhone(phone){
      this.phone = phone
    }
  }
};
</script>

<style lang="scss">
* {
  box-sizing: border-box;
}
html,
body {
  font-family: "Roboto", sans-serif;
}
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
</style>
